import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';


const DividerRoot = styled('div')(({ theme }) => ({
    margin: theme.spacing(1),
    padding: theme.spacing(1),
    //borderRadius: 14,
    //borderColor: theme.palette.common.white,
    //color: theme.palette.primary.dark,
    //backgroundColor: theme.palette.background.paper,
    //textAlign: 'center',
    //width: '90%',

  }));

export const SidebarChapter = (props) => {

    const { chapter, number, accentColor } = props

    return (

<DividerRoot>
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    {number && (
      <Box
        sx={{
          flexShrink: 0,
          width: 22, height: 22,
          borderRadius: '50%',
          border: `1.5px solid ${accentColor}`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}
      >
        <Typography
          variant="body2"
          sx={{ color: accentColor, fontWeight: 600, lineHeight: 1 }}
        >
          {number}
        </Typography>
      </Box>
    )}
    <Typography variant="body2" sx={{color: accentColor, fontWeight: 500, letterSpacing: "0.04em" }} >{chapter}</Typography>
  </Box>
</DividerRoot>

  )}